import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'
import it from './locales/it.json'
import { DEFAULT_LOCALE } from './languages'

export {
  DEFAULT_LOCALE,
  LANGUAGES,
  SUPPORTED_LOCALES,
  isSupportedLocale,
  languageFor,
  type LanguageOption,
  type SupportedLocale,
} from './languages'

const messages = { en, de, it } as const

type MessageSchema = typeof en

declare module 'vue-i18n' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefineLocaleMessage extends MessageSchema {}
}

// Deliberately un-generic: the strict `createI18n<[MessageSchema], SupportedLocale>` form would demand stub catalogues for `de` and `it`.
export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
})
